export class Country {
  countryCode: string
  translation: string

  constructor(countryCode, translation) {
    this.countryCode = countryCode
    this.translation = translation
  }
}

export const allCountries = [
  new Country("AT", "Österreich"),
  new Country("DE", "Deutschland"),
]